import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      let tries = 0;
      let found = 0;
      const t = setInterval(() => {
        const el = document.getElementById(hash.slice(1));
        tries += 1;
        if (el) {
          el.scrollIntoView({ block: 'start' });
          found += 1;
        }
        if (found > 8 || tries > 30) clearInterval(t);
      }, 150);
      return () => clearInterval(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
